import React from "react";
import { createPortal } from "react-dom";
export const ConditionalPortal = ({ children, isActivePortal }) => (React.createElement(React.Fragment, null, isActivePortal ? createPortal(children, document.body) : children));
